import React, { PropTypes } from 'react';
import classNames from 'classnames';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';

// icons
import { icon } from './../../icons/icons';

// actions
import * as actions from './../../actions/actions';

import Warning from './Warning';
import Save from './Save';
import Email from './Email';
import Share from './Share';
import Delete from './Delete';

class Modal extends React.Component {
    constructor(props) {
        super(props);
        this.renderModal = this.renderModal.bind(this);
        this.closeModal = this.closeModal.bind(this);
    }

    afterOpenModal() {
        setTimeout(() => {
            document.body.classList.add('modal-opened');
        }, 10);
    }

    closeModal() {
        document.body.classList.remove('modal-opened');
        setTimeout(() => {
            this.props.actions.setModal(null, null, null);
        }, 400);
    }

    renderModal() {
        switch (this.props.modal.type) {
        case 'WARNING':
            return <Warning buttonPrimary={this.closeModal} modal={this.props.modal} />;
        case 'DELETE':
        case 'DELETE_WIDGET':
            return <Delete buttonSecondary={this.closeModal} modal={this.props.modal} id={this.props.modal.vars} />;
        case 'SAVE':
            return <Save buttonSecondary={this.closeModal} />;
        case 'EMAIL':
            return <Email buttonSecondary={this.closeModal} />;
        case 'SHARE':
            return <Share buttonSecondary={this.closeModal} />;
        default:
            return null;
        }
    }

    render() {
        const { modal } = this.props;
        const modalCss = classNames({
            'modal-content': true,
            'modal-warning': (modal.type === 'WARNING' || modal.type === 'DELETE' || modal.type === 'DELETE_WIDGET'),
        });

        if (modal.type !== null) {
            this.afterOpenModal();
        }

        return (
            (modal.type !== null) ?
                <div key={modal.type} className="modal-overlay">
                    <div className={modalCss}>
                        <span className="modal-close" onClick={this.closeModal}>{icon.close()}</span>
                        { this.renderModal() }
                    </div>
                </div>
            : null
        );
    }
}

const mapStateToProps = (state) => ({
    app: state.app,
    modal: state.modal,
    pages: state.pages,
});

const mapDispatchToProps = (dispatch) => ({
    actions: bindActionCreators(actions, dispatch),
});

Modal.propTypes = {
    app: PropTypes.object.isRequired,
    modal: PropTypes.object.isRequired,
    pages: PropTypes.object.isRequired,
    actions: PropTypes.object.isRequired,
};

export default connect(mapStateToProps, mapDispatchToProps)(Modal);



// WEBPACK FOOTER //
// ./src/_app/quick_response/components/Modals/Modal.jsx